module.exports = __webpack_public_path__ + "img/4.1.772fc551.jpg";